<template>
    <div :class="darkMode ? 'dark' : ''">
        <!-- Messaggio che appare se si accede da mobile e schermi inferiori a md -->
        <div id="onlydesktop" class="block md:!hidden !font-sans">
            <div
                v-if="loggedAs && loggedAs.ruolo === 'admin'"
                id="onlydesktopAdmin"
                class="bg-csenRed-200 py-12 px-10"
            >
                <div
                    class="bg-csenRed-100 text-csenRed-600 p-3 inline-flex rounded-full mb-4"
                >
                    <MobileIcon></MobileIcon>
                </div>
                <div
                    class="bg-csenGreen-100 text-csenGreen-600 p-3 inline-flex rounded-full mb-4"
                >
                    <DesktopIcon></DesktopIcon>
                </div>
                <div>
                    <h2
                        class="text-left text-lg text-csenRed-800 font-bold mb-2"
                    >
                        Accesso non consentito
                    </h2>
                </div>
                <div class="text-left text-csenRed-900 text-base font-semibold">
                    L'accesso come amministratore
                    <strong>non è consentito da mobile</strong>.
                </div>
                <div
                    class="text-left text-csenRed-900 mt-1 text-base font-semibold"
                >
                    Collegati da un <strong>computer desktop</strong> per
                    svolgere le attività come amministratore.
                </div>
            </div>
        </div>

        <div
            id="maincontainer"
            :class="{
                '!hidden': loggedAs && loggedAs.ruolo === 'admin',
                'md:!block': loggedAs && loggedAs.ruolo === 'admin',
            }"
            class="sm:px-[5%] !font-sans bg-white dark:bg-[#171a35]"
        >
            <!-- Messaggio temporaneo-->
            <div
                class="!mx-3 md:!mx-0 py-3 !font-sans"
                v-if="
                    isCardVisible &&
                    (loggedAs.ruolo == null || loggedAs.ruolo == 'tecnico')
                "
            >
                <template>
                    <v-card
                        class="!bg-csenGreen-200/75 dark:!bg-csenGreen-600 !border-0 !ring-0 p-1"
                    >
                        <v-card-title>
                            <h2
                                class="!mb-1 font-sans !text-[0.8rem] leading-5 md:!text-[0.9rem] text-csenGreen-950 dark:text-white !break-words"
                            >
                                <span class="font-semibold">
                                    <span class="dark:filter dark:contrast-200"
                                        >✨</span
                                    >
                                    Il nuovo Albo Tecnici CSEN è online! </span
                                ><span
                                    class="block md:!inline-flex !mt-1 md:!mt-0 font-normal dark:text-csenGreen-200"
                                    >Scopri tutte le nuove funzionalità.</span
                                >
                            </h2>
                            <v-spacer></v-spacer>
                            <v-btn
                                icon
                                @click="closeCard"
                                class="!hidden md:!block"
                            >
                                <v-icon
                                    class="!text-csenGreen-800 dark:!text-white"
                                    >mdi-close</v-icon
                                >
                            </v-btn>
                        </v-card-title>
                        <v-card-subtitle
                            class="!text-csenGreen-700 dark:!text-csenGreen-100"
                        >
                            <div
                                class="!ml-0 md:!ml-2 !text-xs md:!text-sm flex justify-between items-center"
                            >
                                <div>
                                    <div>
                                        Per accedere cerca il tuo nome e cognome
                                        nella barra di ricerca qui sotto e
                                        clicca su <strong>"Accedi"</strong> in
                                        corrispondenza del tuo nominativo.
                                    </div>
                                    <div class="!mt-1 md:!mt-0">
                                        Una volta effettuato l’accesso potrai
                                        rinnovare il tuo patentino / tesserino
                                        (se non rinnovi già in autonomia con il
                                        tuo Referente), stampare i bollini dei
                                        tuoi rinnovi, vedere il tuo storico di
                                        diplomi e rinnovi e verificare i tuoi
                                        dati anagrafici.
                                    </div>
                                </div>
                            </div>
                            <div
                                class="!hidden md:!flex justify-start self-start pt-3 ml-2"
                            >
                                <v-btn
                                    @click="closeCard"
                                    class="!bg-csenGreen-600 dark:!bg-csenGreen-800 !text-white"
                                    ><span class="!text-xs tracking-wide"
                                        >Ok ho capito, chiudi questo
                                        avviso</span
                                    ></v-btn
                                >
                            </div>
                        </v-card-subtitle>
                        <v-card-actions class="!block md:!hidden !-mt-3"
                            ><v-btn
                                @click="closeCard"
                                class="!bg-csenGreen-600 dark:!bg-csenGreen-800 !text-white !w-full"
                                ><span class="!text-xs tracking-wide"
                                    >Ok ho capito, chiudi questo avviso</span
                                ></v-btn
                            ></v-card-actions
                        >
                    </v-card>
                </template>
            </div>

            <!-- HEADER -->
            <div>
                <div
                    class="bg-csenBlue-950 dark:bg-csenBlue-900 !p-8 md:!p-12 rounded-b-none md:rounded-b-md"
                >
                    <!-- MENU TECNICI -->
                    <div>
                        <MenuTecnici @avvia-guida="avviaTour"></MenuTecnici>
                    </div>
                    <!-- INIZIO RICERCA -->
                    <div
                        id="search-bar"
                        flat
                        class="md:!mt-6 flex bg-white px-3 py-3 rounded-md gap-x-2"
                    >
                        <div class="group inline-flex relative">
                            <v-badge
                                v-if="numFiltriAttivi"
                                color="#e26d14"
                                dot
                                overlap
                                offset-x="7"
                                offset-y="7"
                            >
                                <!-- Il bottone rimane sempre visibile -->
                                <v-btn
                                    @click="openFiltersDialog()"
                                    class="!text-white tracking-wide flex items-center gap-x-2 px-5 !bg-csenBlue-900 hover:!bg-csenBlue-800 !py-6 !rounded-md"
                                    title="Filtra risultati"
                                >
                                    <FilterIcon
                                        class="text-csenBlue-300 group-hover:text-csenOrange-100"
                                    ></FilterIcon>
                                    <span
                                        class="!text-base !font-normal !ml-1.5 !tracking-wide"
                                        >Filtra</span
                                    >
                                </v-btn>
                            </v-badge>
                            <template v-else>
                                <!-- Mostra il bottone senza il badge se non ci sono filtri attivi -->
                                <v-btn
                                    @click="openFiltersDialog()"
                                    class="!text-white tracking-wide flex items-center rounded-md !mx-auto !py-6 gap-x-2 !bg-csenBlue-900 hover:!bg-csenBlue-800"
                                    title="Filtra risultati"
                                >
                                    <FilterIcon
                                        class="text-csenBlue-300 group-hover:text-csenOrange-100"
                                    ></FilterIcon>
                                    <span
                                        class="hidden md:!block !text-base !font-normal !ml-2 !tracking-wide"
                                        >Filtra</span
                                    >
                                </v-btn>
                            </template>
                        </div>
                        <div
                            class="group inline-flex bg-red-200 hover:bg-red-300 rounded-md transition sm:ml-1 sm:mr-2"
                        ></div>
                        <v-text-field
                            v-model="search"
                            hide-details
                            flat
                            solo
                            light
                            class="relative w-full border-none rounded-lg"
                            prepend-icon="mdi-magnify"
                            clearable
                            placeholder="Cerca un tecnico"
                            clear-icon="mdi-close-circle-outline"
                            @click:clear="resetSearch()"
                        ></v-text-field>
                    </div>
                    <!-- FINE RICERCA -->
                </div>
            </div>

            <!-- LINK ALLE FAQ (SOLO MOBILE) -->
            <div class="block sm:hidden mx-5 mt-5 -mb-2">
                <v-btn
                    @click="redirectToFAQ()"
                    class="group w-full !bg-gray-100 dark:!bg-csenBlue-900 !text-csenBlue-800 dark:!text-white !tracking-normal !transition !py-6"
                >
                    <ChatIcon
                        class="text-csenBlue-400 mr-2 !h-5 !w-5"
                    ></ChatIcon>
                    <span class="underline dark:!no-underline">
                        Hai dei dubbi o dei problemi?</span
                    >
                </v-btn>
            </div>

            <!-- PULSANTI AZIONI -->
            <div class="flex my-5 mb-2 rounded-md">
                <div v-if="numFiltriAttivi > 0" class="flex justify-start ml-5">
                    <v-btn
                        @click="openFiltersDialog()"
                        class="cursor-pointer bg-gray-200 dark:!bg-csenBlue-800/50 !px-4 !py-6 rounded-md inline-flex"
                    >
                        <InfoIcon
                            class="mr-2 text-csenOrange-500 my-auto"
                        ></InfoIcon>
                        <span
                            class="my-auto text-sm !tracking-normal text-gray-700 dark:!text-white"
                        >
                            Stai utilizzando:
                            <span
                                class="font-bold text-gray-900 dark:text-csenOrange-500"
                            >
                                {{
                                    numFiltriAttivi == 1
                                        ? numFiltriAttivi + " filtro"
                                        : numFiltriAttivi + " filtri"
                                }}</span
                            >
                        </span>
                    </v-btn>
                    <v-btn
                        @click="$refs['filtersComponent'].resetFiltri()"
                        plain
                        class="!my-auto !bg-transparent hover:!bg-transparent !p-0 -ml-2 !text-csenBlue-900 dark:!text-white hover:!text-csenRed-700 dark:hover:!text-csenRed-500 transition"
                    >
                        <CloseCircleIcon></CloseCircleIcon>
                    </v-btn>
                </div>
                <div
                    class="flex justify-end"
                    v-if="loggedAs && loggedAs.ruolo == 'admin'"
                >
                    <v-btn
                        id="excel-import"
                        @click="openUploadExcelDialog()"
                        title="Carica Excel dei tecnici associati ad un diploma "
                        class="mr-2 !bg-gray-100 dark:!bg-csenBlue-900 !text-csenBlue-800 dark:!text-white !tracking-normal !shadow-md !py-6"
                    >
                        <UploadIcon
                            class="mr-2 text-csenGreen-400 dark:!text-csenGreen-300"
                        ></UploadIcon>
                        <span class="underline dark:!no-underline"
                            >Carica tecnici (Excel)</span
                        >
                    </v-btn>
                    <v-btn
                        id="invio-circolare-manuale"
                        title="Invia una circolare ai tecnici selezionati"
                        :disabled="numTotaleTecnici == 0"
                        @click="openCircolareDialog()"
                        class="!bg-gray-100 dark:!bg-csenBlue-900 !text-csenBlue-800 dark:!text-white !tracking-normal !shadow-md !py-6"
                    >
                        <ReplyAllIcon
                            class="text-csenBlue-300 mr-2"
                        ></ReplyAllIcon>
                        <span class="underline dark:!no-underline"
                            >Invio manuale di una circolare</span
                        >
                    </v-btn>
                    <v-btn
                        id="aggiugi-tecnico-btn"
                        class="!bg-csenBlue-900 dark:!bg-csenBlue-700 !text-white !tracking-normal !py-6 ml-2"
                        @click="apriPannelloTecnico(null)"
                    >
                        <PersonAddIcon
                            class="text-csenBlue-300 mr-2"
                        ></PersonAddIcon>
                        <span>Nuovo tecnico</span>
                        <!-- Aggiungi -->
                    </v-btn>
                </div>

                <div
                    class="!mx-5 md:!mx-0 sm:grid sm:grid-cols-1 w-full"
                    v-if="loggedAs && loggedAs.ruolo == 'tecnico'"
                >
                    <div class="sm:flex justify-end content-end gap-2">
                        <v-btn
                            @click="
                                visualizzaInteroPannelloTecnico(loggedAs.id)
                            "
                            class="!bg-csenOrange-500 !w-full sm:!w-[180px] sm:!max-w-[180px] dark:!bg-csenOrange-600 !text-white !tracking-normal hover:!bg-csenOrange-600 dark:hover:!bg-csenOrange-600 !transition !py-6"
                        >
                            <UserIcon
                                class="text-csenOrange-200 mr-2 !h-5 !w-5"
                            ></UserIcon>
                            <span> La mia scheda</span>
                        </v-btn>
                        <!-- Spostato altrove -->
                        <!-- <v-btn @click="redirectToFAQ()" class="block sm:hidden group !mt-2 sm:!mt-0 !w-full sm:!w-[270px] sm:!max-w-[270px] !bg-gray-100 dark:!bg-csenBlue-900 !text-csenBlue-800 dark:!text-white !tracking-normal !transition !py-6">
					<ChatIcon class="text-csenBlue-400 mr-2 !h-5 !w-5"></ChatIcon>
					<span class="underline  dark:!no-underline"> Hai dei dubbi o dei problemi?</span>
					</v-btn> -->
                    </div>
                    <!-- !bg-csenBlue-900 dark:!bg-csenBlue-700 !text-white !tracking-normal  -->
                </div>
            </div>
            <!-- FINE PULSANTI AZIONI -->
            <!-- TABELLA TECNICO INIZIO //itemsPerPageText: $vuetify.breakpoint.xs ? '' : 'Tecnici per pagina', -->
            <template>
                <div id="tabella" class="py-3">
                    <v-data-table
                        id="tecnici-table"
                        class="tabella-csen"
                        :key="tableKey"
                        :headers="headersDaMostrare"
                        :items="tecnici"
                        :loading="isLoading"
                        :server-items-length="numTotaleTecnici"
                        :footer-props="{
                            itemsPerPageOptions: [5, 10, 25, 50, 100, 2000],
                            itemsPerPageText: $vuetify.breakpoint.xs
                                ? ''
                                : 'Tecnici per pagina',
                            showCurrentPage: true,
                            showFirstLastPage: false,
                        }"
                        :options.sync="tableOptions"
                        :item-class="getRigaTecnicoClass"
                    >
                        <template v-slot:item.ultimo_rinnovo="{ item }">
                            <template
                                v-if="
                                    isUltimoRinnovoDaMostrare(
                                        item.ultimo_rinnovo
                                    )
                                "
                            >
                                <div
                                    class="inline-flex gap-x-1 py-1.5 px-2 ml-1 text-xs font-medium text-csenGreen-500 dark:text-white bg-csenGreen-100 dark:bg-csenGreen-500 rounded-full"
                                >
                                    <VerifiedIcon></VerifiedIcon>
                                    {{ item.ultimo_rinnovo }}
                                </div>
                            </template>
                            <template v-else>
                                <!-- Condizione per mostrare il tooltip solo se loggedAs.ruolo è null o 'tecnico' -->
                                <template
                                    v-if="
                                        loggedAs.ruolo == null ||
                                        loggedAs.ruolo == 'tecnico'
                                    "
                                >
                                    <v-tooltip right content-class="!text-sm">
                                        <template
                                            v-slot:activator="{ on, attrs }"
                                        >
                                            <div
                                                class="inline-flex gap-x-1 py-1.5 px-2 ml-1 text-xs font-medium text-csenRed-500 dark:text-white bg-csenRed-50 dark:bg-csenRed-500 rounded-full"
                                                v-bind="attrs"
                                                v-on="on"
                                            >
                                                <WarningIcon></WarningIcon>
                                                Iscrizione Scaduta
                                            </div>
                                        </template>
                                        <span
                                            >Per rinnovare accedi e vai alla
                                            sezione "Rinnovi"</span
                                        >
                                    </v-tooltip>
                                </template>
                                <!-- Altrimenti, mostra solo il div senza il tooltip -->
                                <template v-else>
                                    <div
                                        class="inline-flex gap-x-1 py-1.5 px-2 ml-1 text-xs font-medium text-csenRed-500 dark:text-white bg-csenRed-50 dark:bg-csenRed-500 rounded-full"
                                    >
                                        <WarningIcon></WarningIcon>
                                        Iscrizione Scaduta
                                    </div>
                                </template>
                            </template>
                        </template>
                        <template v-slot:item.nomi_corsi="{ item }">
                            <span v-if="!item.mostra_tutti_i_corsi">
                                {{ item.nomi_corsi[0] }}
                            </span>
                            <span v-else>
                                <!-- Mantenere il commento per questa alternativa grafica -->
                                <!-- <span v-for="(el, idx) in item.nomi_corsi" :key="idx">
							{{ idx == 0 ? el : ' - ' + el }}
							</span>  -->
                                <span
                                    v-for="(el, idx) in item.nomi_corsi"
                                    :key="idx"
                                    class="!block"
                                >
                                    {{ "· " + el }}
                                </span>
                            </span>
                            <template
                                v-if="
                                    item.nomi_corsi.length - 1 >= 1 &&
                                    !item.mostra_tutti_i_corsi
                                "
                                title="Mostra altri diplomi"
                            >
                                <span
                                    @click="mostraTuttiICorsi(item)"
                                    class="p-1.5 ml-1 text-xs font-medium text-csenBlue-800 dark:text-white bg-csenBlue-50 dark:bg-csenBlue-700 cursor-pointer hover:bg-csenBlue-200 dark:hover:bg-csenBlue-800 rounded-md transition"
                                >
                                    <slot
                                        >+{{ item.nomi_corsi.length - 1 }}</slot
                                    >
                                </span>
                            </template>
                        </template>

                        <template v-slot:item.data_nascita="{ item }">
                            {{ formattaData(item.data_nascita) }}
                        </template>

                        <template v-slot:item.circolari_abilitate="{ item }">
                            <BadgeSi v-if="item.circolari_abilitate"></BadgeSi>
                            <BadgeNo v-else></BadgeNo>
                        </template>
                        <template v-slot:item.email="{ item }">
                            <a
                                target="_blank"
                                href="mailto:item.email"
                                class="text-csenBlue-700 dark:text-csenBlue-100 dark:hover:text-white hover:underline transition hover:text-csenBlue-700"
                            >
                                {{ item.email }}
                            </a>
                        </template>
                        <!-- AZIONI TABELLA -->
                        <template v-slot:item.azioni="{ item }">
                            <div class="text-right">
                                <template v-if="loggedAs.ruolo == null">
                                    <v-btn
                                        class="text-right !bg-gray-100 !text-csenBlue-800 dark:!text-white dark:!bg-csenBlue-600 !tracking-normal"
                                        @click="openLoginTecnicoDialog(item.id)"
                                    >
                                        <v-icon left>mdi-login</v-icon>
                                        Accedi
                                    </v-btn>
                                </template>
                                <template v-if="loggedAs.ruolo == 'admin'">
                                    <div class="d-flex justify-end gap-1">
                                        <button
                                            id="modifica-tecnico"
                                            type="button"
                                            @click="apriPannelloTecnico(item)"
                                            class="bg-csenOrange-100 dark:bg-csenOrange-500 !text-csenOrange-500 dark:!text-white hover:dark:!brightness-125 p-1 rounded-md hover:bg-csenOrange-500 hover:!text-white transition"
                                            title="Modifica"
                                        >
                                            <EditIcon></EditIcon>
                                        </button>
                                        <button
                                            id="elimina-tecnico"
                                            type="button"
                                            @click="eliminaTecnico(item)"
                                            class="bg-red-100 dark:bg-csenRed-500 !text-csenRed-500 dark:!text-white hover:dark:!brightness-125 p-1 rounded-md hover:bg-csenRed-500 hover:!text-white transition"
                                            title="Elimina"
                                        >
                                            <DeleteIcon></DeleteIcon>
                                        </button>
                                    </div>
                                </template>
                                <!-- Nascosta la colonna azioni tramite gli headers se loggato come tecnico -->
                                <!-- <template v-if="loggedAs.ruolo == 'tecnico' && loggedAs.id == item.id">
							<div class="d-flex justify-end gap-1">
								<button
								type="button"
								@click="visualizzaInteroPannelloTecnico(item.id)"
								class=" bg-csenOrange-100 text-csenOrange-500 p-1 rounded-md hover:bg-csenOrange-500 hover:text-white transition"
								title="Modifica"
								>
								<EditIcon></EditIcon>
								</button>
							</div>
							</template> -->
                            </div>
                        </template>
                    </v-data-table>
                </div>
            </template>
            <!-- TABELLA TECNICO FINE -->
            <!-- ACCESSO ADMIN -->
            <div
                class="block sm:flex gap-2 border-t border-t-gray-300 dark:border-t-csenBlue-300 pt-4 mt-3"
            >
                <template>
                    <v-btn
                        id="select-column"
                        v-if="loggedAs.ruolo == 'admin'"
                        @click="openFilterHeadersDialog()"
                        class="!block !mb-2 sm:!inline sm:!mb-0 !text-csenBlue-800 !bg-gray-200 dark:!bg-csenBlue-600 dark:!text-white"
                    >
                        <v-icon small>mdi-minus</v-icon>
                        <v-icon>mdi-view-column-outline</v-icon>
                        <v-icon small>mdi-plus</v-icon>
                    </v-btn>
                </template>
                <template>
                    <v-btn
                        v-if="loggedAs.id == null"
                        class="!hidden md:!flex !m-auto mb-4 !justify-center md:!ml-0 md:!justify-start md:!mb-2 sm:!inline sm:!mb-0 !tracking-normal !bg-csenBlue-100 !text-csenBlue-600 dark:!text-white dark:!bg-csenBlue-700"
                        @click="openLoginAdminDialog()"
                    >
                        <!--@click="doLoginAdmin -->
                        <v-icon left>mdi-lock</v-icon>
                        Accesso Amministrativo
                    </v-btn>
                </template>
                <template>
                    <v-btn
                        v-if="
                            loggedAs &&
                            loggedAs.ruolo &&
                            loggedAs.ruolo.length > 0
                        "
                        class="!ml-3 !mb-4 !md:mb-2 md:!ml-0 !block sm:!inline sm:!mb-0 !tracking-normal !bg-slate-200 !text-slate-600 dark:!text-white dark:!bg-csenBlue-800"
                        @click="logout"
                    >
                        <v-icon left>mdi-logout</v-icon>
                        Logout
                    </v-btn>
                </template>
                <div
                    class="flex !justify-end gap-2"
                    v-if="loggedAs && loggedAs.ruolo == 'admin'"
                >
                    <v-btn
                        id="export-bar"
                        class="!tracking-normal !bg-csenGreen-100 !text-csenGreen-600 dark:!text-white dark:!bg-csenGreen-600"
                        @click="openExportDialog"
                    >
                        <!-- <DocumentIcon class="text-csenGreen-600 dark:!text-csenGreen-200"></DocumentIcon> -->
                        <TableIcon
                            class="text-csenGreen-600 dark:!text-csenGreen-200"
                        ></TableIcon>
                        <span class="ml-2">Esporta</span>
                        <v-progress-circular
                            :size="20"
                            :width="3"
                            class="ml-2 !fill-white"
                            v-if="isExporting"
                            indeterminate
                        ></v-progress-circular>
                    </v-btn>
                </div>
            </div>
            <!-- <div class="mb-6 mt-4 px-4 text-sm dark:text-white">
			 <div v-if="loggedAs.ruolo==null">Non loggato!</div>
			 <div v-if="loggedAs.ruolo=='admin'">Loggato come admin (id: {{ loggedAs.id }})</div>
			 <div v-if="loggedAs.ruolo=='tecnico'">Loggato come tecnico (id: {{ loggedAs.id }})</div>
			 </div> -->
            <!-- FINE ACCESSO ADMIN -->
            <!-- PANNELLO TECNICI -->
            <template>
                <!-- Rendo il dialog eager per caricarlo fin da subito (utile per la guida) -->
                <!--  -->
                <v-dialog
                    :eager="true"
                    v-model="pannelloTecnicoDialog"
                    max-width="1200px"
                    persistent
                >
                    <v-card
                        plain
                        class="dark:!bg-csenBlue-900 dark:!ring-0 dark:!border-0 !rounded-md"
                    >
                        <v-card-title
                            class="bg-csenBlue-900 dark:bg-csenBlue-800 text-white font-bold text-2xl py-6 pl-8"
                        >
                            <span class="flex-grow">
                                <h2 v-if="idTecnicoDaAprire == null">
                                    Aggiungi un nuovo tecnico
                                </h2>
                                <h2 v-else>
                                    Modifica scheda del tecnico:
                                    <span class="text-csenBlue-200">{{
                                        nomeCognomeTecnicoVisualizzato
                                    }}</span>
                                </h2>
                            </span>
                        </v-card-title>
                        <v-card-text class="!m-0 !p-0">
                            <PannelloTecniciComponente
                                ref="pannelloTecniciRef"
                                @tecnico-modificato="isTecnicoModificato = true"
                                :tecnico-id="idTecnicoDaAprire"
                                @aggiungi-tecnico-senza-chiudere-dialog="
                                    (vaiATab) =>
                                        validaTecnico(
                                            (chiudiDialog = false),
                                            vaiATab
                                        )
                                "
                                :vai-a-tab="vaiATabTecnico"
                            />
                        </v-card-text>
                        <v-card-actions
                            class="p-4 justify-end bg-gray-300 dark:bg-csenBlue-800 sticky bottom-0 z-40"
                        >
                            <v-btn
                                id="annulla-torna-elenco"
                                class="!bg-gray-400/30 dark:!bg-transparent !tracking-wider !py-5 !px-4"
                                text
                                @click="chiudiPannelloTecnicoConferma()"
                            >
                                <LeftArrowIcon
                                    class="!text-gray-500 dark:!text-csenBlue-400 mr-2"
                                ></LeftArrowIcon>
                                Annulla e torna all'elenco
                            </v-btn>
                            <v-btn
                                :disabled="!isTecnicoModificato"
                                :class="
                                    (isTecnicoModificato
                                        ? '!bg-csenGreen-500 !text-white '
                                        : '') + '!tracking-wider !py-5 !px-5'
                                "
                                text
                                @click="validaTecnico()"
                                >Salva e torna all'elenco</v-btn
                            >
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </template>
            <!-- PANNELLO TECNICI FINE -->
            <!-- PANNELLO INVIO CIRCOLARE -->
            <template>
                <v-dialog v-model="circolareDialog" width="1200px" persistent>
                    <v-card plain class="dark:!bg-csenBlue-800">
                        <v-card-title class="font-bold text-2xl py-6 pl-8">
                            <span class="flex-grow">
                                <h2>
                                    Invia una circolare a
                                    <span
                                        class="text-csenBlue-700 dark:text-csenOrange-500"
                                        >{{ numTotaleTecnici }}</span
                                    >
                                    tecnici, ad eccezione di quelli non
                                    abilitati alla ricezione delle circolari
                                    massive
                                </h2>
                            </span>
                            <v-btn
                                class="!text-gray-900 dark:!text-white"
                                icon
                                @click="closeCircolareDialog()"
                            >
                                <CloseIcon />
                            </v-btn>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text class="!m-0 !p-0">
                            <div class="my-5 pt-5 mx-8">
                                <!-- <div>
							<p class="text-sm font-semibold mt-4 mb-0 ml-3 tracking-wide !text-gray-800">Seleziona Modello E-mail</p>
							</div> -->
                                <v-form ref="selezionaCircolareForm">
                                    <v-autocomplete
                                        label="Seleziona un modello email"
                                        autocomplete="none"
                                        v-model="
                                            idModelloEmailCircolareSelezionato
                                        "
                                        :items="modelliEmailDisponibili"
                                        item-value="id"
                                        item-text="nome"
                                        outlined
                                        clearable
                                        :rules="[rules.required]"
                                    ></v-autocomplete>
                                    <v-select
                                        v-if="
                                            modelloEmailSelezionatoHasRiferimentoRinnovo
                                        "
                                        v-model="
                                            annoRinnovoRiferimentoCircolareSelezionato
                                        "
                                        :items="anniDisponibili"
                                        label="Seleziona l'anno di riferimento del rinnovo"
                                        outlined
                                        :rules="[rules.required]"
                                    ></v-select>
                                </v-form>
                                <div
                                    class="!font-sans text-lg text-csenBlue-950 dark:text-csenBlue-100 mb-4 pt-5 border-t !border-t-gray-200 dark:!border-t-csenBlue-600 font-semibold"
                                    v-if="idModelloEmailCircolareSelezionato"
                                >
                                    🔍 La seguente è un'anteprima dell'email che
                                    verrà utilizzata:
                                </div>
                                <div cursor-none>
                                    <ModelloEmailComponent
                                        v-if="
                                            idModelloEmailCircolareSelezionato
                                        "
                                        :id="idModelloEmailCircolareSelezionato"
                                        :only-view="true"
                                        disabled
                                        cursor-none
                                    ></ModelloEmailComponent>
                                </div>
                            </div>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions
                            class="p-4 justify-end bg-gray-200 dark:!bg-csenBlue-800 dark:border-t dark:border-csenBlue-200/10 sticky bottom-0 z-40"
                        >
                            <v-btn
                                class="!bg-white!tracking-wider !py-5 !px-5"
                                text
                                @click="closeCircolareDialog()"
                                >Annulla</v-btn
                            >
                            <v-btn
                                class="!bg-csenBlue-900 !text-white !tracking-wider !py-5 !px-5"
                                text
                                @click="openCircolareConfermaDialog()"
                                >Avanti</v-btn
                            >
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </template>
            <!-- PANNELLO INVIO CIRCOLARE FINE -->
            <!-- PANNELLO LOGIN TECNICO -->
            <template>
                <v-dialog
                    v-model="loginTecnicoDialog"
                    width="1200px"
                    persistent
                >
                    <v-card plain class="dark:!bg-csenBlue-800">
                        <v-card-title
                            class="font-bold text-2xl !py-4 md:!py-6 pl-8"
                        >
                            <span class="flex-grow">
                                <h2>
                                    Benvenuto
                                    <span class="!hidden md:!inline-flex"
                                        >nell'Albo Tecnici CSEN Corsi</span
                                    >
                                </h2>
                            </span>
                            <v-btn
                                class="!text-gray-900 dark:!text-white"
                                icon
                                @click="loginTecnicoDialog = false"
                            >
                                <CloseIcon />
                            </v-btn>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text class="!m-0 !p-0 !font-sans">
                            <div
                                v-if="
                                    !suggerimentoEmailLoaded ||
                                    suggerimentoEmail
                                "
                                class="my-5 mx-8 text-neutral-700 dark:text-white"
                            >
                                <span>
                                    <strong>
                                        Inserisci
                                        <span
                                            class="text-neutral-900 dark:text-white"
                                            >l'email che hai fornito in fase di
                                            iscrizione al corso</span
                                        >
                                        qui sotto
                                    </strong>
                                </span>
                                <v-text-field
                                    label="Inserisci l'email"
                                    :hint="
                                        'Suggerimento: ' +
                                        (suggerimentoEmailLoaded
                                            ? suggerimentoEmail
                                            : 'In caricamento..')
                                    "
                                    persistent-hint
                                    outlined
                                    v-model="emailInseritaLoginTecnico"
                                    type="email"
                                    class="!mt-3 hint-color"
                                ></v-text-field>
                                <span>
                                    <br />
                                    Se non ricordi l'indirizzo email con cui ti
                                    sei iscritto, leggi il suggerimento oppure
                                    controlla sul modulo di iscrizione.<br />
                                    Se l'indirizzo email corrisponde a quello
                                    fornito in fase di iscrizione,
                                    <span
                                        class="text-csenOrange-500 dark:text-csenOrange-500"
                                        ><strong
                                            >riceverai un'email contenente il
                                            link di accesso</strong
                                        ></span
                                    >
                                    alla tua scheda personale, dove potrai:
                                    <ul style="list-style-type: disc">
                                        <li>
                                            Controllare e modificare i tuoi dati
                                            anagrafici
                                        </li>
                                        <li>
                                            Rinnovare il tuo patentino/tesserino
                                            cartaceo blu (se non rinnovi già in
                                            autonomia con il tuo Referente)
                                        </li>
                                        <li>
                                            Stampare i bollini dei tuoi rinnovi
                                        </li>
                                        <li>
                                            Vedere lo storico dei tuoi diplomi e
                                            dei tuoi rinnovi
                                        </li>
                                    </ul>
                                    <br />
                                    <span class="mb-1">
                                        Per accedere alla tua scheda personale
                                        ti basterà
                                        <strong
                                            >cliccare il link d'accesso ricevuto
                                            via email</strong
                                        >, senza dover inserire alcuna password. </span
                                    ><br />
                                    Se non ricordi la tua email di accesso
                                    scrivi a
                                    <a
                                        class="!text-csenBlue-500 hover:!text-csenBlue-600 dark:!text-csenOrange-500 dark:hover:!text-csenOrange-400 transition underline"
                                        href="mailto:info@tecnici.csencorsi.it"
                                        >info@tecnici.csencorsi.it</a
                                    >
                                </span>
                            </div>

                            <div
                                v-else
                                class="my-5 mx-8 text-neutral-700 dark:text-white"
                            >
                                <div class="mb-3 mt-6">
                                    <strong>
                                        <span
                                            class="font-bold dark:text-csenRed-400 text-csenRed-500"
                                            >Impossibile accedere</span
                                        >
                                    </strong>
                                </div>
                                <div>
                                    Per accedere e usufruire dei servizi
                                    dell'Albo Tecnici è fondamentale avere
                                    <strong>un'email associata</strong> alla
                                    propria anagrafica di tecnico. <br />Al
                                    momento però non risulta
                                    <span
                                        class="font-bold dark:text-csenRed-400 text-csenRed-500"
                                        >nessun indirizzo email</span
                                    >.

                                    <div class="mt-2">
                                        Per poter associare un'email alla tua
                                        anagrafica e procedere con l'accesso, ti
                                        chiediamo di scrivere a
                                        <a
                                            class="!text-csenBlue-500 hover:!text-csenBlue-600 dark:!text-csenOrange-500 dark:hover:!text-csenOrange-400 transition underline"
                                            href="mailto:info@tecnici.csencorsi.it"
                                            >info@tecnici.csencorsi.it</a
                                        >
                                        allegando
                                        <strong
                                            >copia della tua tessera
                                            sanitaria</strong
                                        >
                                        e indicando
                                        <strong
                                            >l'indirizzo email che vuoi
                                            associare</strong
                                        >
                                    </div>
                                    <div class="mb-4">
                                        Una volta effettuato l'accesso potrai:
                                        <ul style="list-style-type: disc">
                                            <li>
                                                Controllare e modificare i tuoi
                                                dati anagrafici
                                            </li>
                                            <li>
                                                Rinnovare il tuo
                                                patentino/tesserino cartaceo blu
                                                (se non rinnovi già in autonomia
                                                con il tuo Referente)
                                            </li>
                                            <li>
                                                Stampare i bollini dei tuoi
                                                rinnovi
                                            </li>
                                            <li>
                                                Vedere lo storico dei tuoi
                                                diplomi e dei tuoi rinnovi
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions
                            class="sticky bottom-0 z-40 p-4 justify-end !bg-gray-100 md:!bg-white dark:!bg-csenBlue-700 md:dark:bg-csenBlue-800"
                        >
                            <v-btn
                                class="!tracking-wider !py-5 !px-5"
                                text
                                @click="loginTecnicoDialog = false"
                                >Annulla</v-btn
                            >
                            <v-btn
                                v-if="suggerimentoEmail"
                                class="!bg-csenBlue-900 !text-white !tracking-wider !py-5 !px-5"
                                text
                                @click="doLoginTecnico()"
                                @keyup.enter="doLoginTecnico()"
                                >Accedi</v-btn
                            >
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </template>
            <!-- PANNELLO LOGIN TECNICO FINE -->
            <!-- PANNELLO CONFERMO INVIO CIRCOLARE -->
            <template>
                <v-dialog
                    v-model="circolareConfermaDialog"
                    width="600px"
                    persistent
                >
                    <v-card plain class="dark:!bg-csenBlue-800">
                        <v-card-title class="font-bold text-2xl py-6 pl-8">
                            <span class="flex-grow">
                                <h2>Conferma invio circolare</h2>
                            </span>
                            <v-btn
                                class="!text-gray-900 dark:!text-white"
                                icon
                                @click="closeCircolareConfermaDialog()"
                            >
                                <CloseIcon />
                            </v-btn>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text
                            class="!m-0 !p-0 dark:!text-white !font-sans"
                        >
                            <div class="my-5 mx-8 text-center">
                                <div class="text-csenBlue-950 dark:!text-white">
                                    Confermi di voler inviare la circolare
                                    <h2
                                        class="text-xl dark:text-orange-400 font-bold my-2"
                                    >
                                        <span class="dark:text-white">"</span>
                                        {{
                                            nomeModelloEmailCircolareSelezionatoComputed
                                        }}
                                        <span class="dark:text-white">"</span>
                                    </h2>
                                    ai
                                    <span
                                        class="text-csenBlue-800 dark:text-csenOrange-300 font-bold text-lg"
                                        >{{ numTotaleTecnici }}</span
                                    >
                                    tecnici selezionati <br />
                                    (ad eccezione di quelli non abilitati alla
                                    ricezione delle circolari massive)?
                                </div>
                            </div>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions
                            class="p-4 justify-end bg-gray-200 dark:!bg-csenBlue-800"
                        >
                            <v-btn
                                class="!bg-white!tracking-wider !py-5 !px-5"
                                text
                                @click="closeCircolareConfermaDialog()"
                                >Indietro</v-btn
                            >
                            <v-btn
                                class="!bg-csenGreen-500 !text-white !tracking-wider !py-5 !px-5"
                                text
                                @click="openCircolareFeedbackDialog()"
                                >Invia</v-btn
                            >
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </template>
            <!-- PANNELLO CONFERMO INVIO CIRCOLARE FINE -->
            <!-- PANNELLO FEEDBACK INVIO CIRCOLARE -->
            <template>
                <v-dialog
                    v-model="circolareFeedbackDialog"
                    width="600px"
                    persistent
                >
                    <v-card
                        plain
                        class="dark:!bg-csenBlue-800 dark:!text-white"
                    >
                        <v-card-title class="font-bold text-2xl py-6 pl-8">
                            <span class="flex">
                                <SuccessIcon
                                    class="my-auto text-csenGreen-600"
                                ></SuccessIcon>
                                <h2 class="ml-2">Email inviata</h2>
                            </span>
                            <v-btn
                                class="!text-gray-900 dark:!text-white"
                                icon
                                @click="closeCircolareFeedbackDialog()"
                            >
                                <CloseIcon />
                            </v-btn>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text class="!m-0 !p-0">
                            <div class="my-5 mx-8">
                                <div class="text-csenBlue-950 dark:!text-white">
                                    Sono state inviate fino a
                                    <span
                                        class="text-csenBlue-800 dark:text-orange-400 font-bold text-lg"
                                        >{{ numTotaleTecnici }}</span
                                    >
                                    circolari. Potrebbero essere necessari fino
                                    a
                                    {{
                                        parseInt(
                                            (numTotaleTecnici / 600).toFixed(0),
                                            10
                                        ) + 2
                                    }}
                                    minuti per raggiungere tutti i destinatari.
                                    <!-- Si fa /600 perché se ne considerano 100 inviate ogni 10s (in realtà in teoria la velocità massima attuale è di 100s, anche se non viene raggiunta), quindi al minuto sono 100x6=600 -->
                                </div>
                            </div>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions
                            class="p-4 justify-end bg-white dark:!bg-csenBlue-800"
                        >
                            <v-btn
                                class="!bg-csenBlue-900 !text-white !tracking-wider !py-5 !px-5"
                                text
                                @click="closeCircolareFeedbackDialog"
                                >Chiudi</v-btn
                            >
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </template>
            <!-- PANNELLO FEEDBACK INVIO CIRCOLARE FINE -->
            <v-dialog
                v-model="filtersDialog"
                :width="`${
                    this.$vuetify.breakpoint.smAndDown ? '100%' : 'unset'
                }`"
                content-class="dark:!bg-csenBlue-800"
                class="dark:!bg-csenBlue-800"
                persistent
                max-width="850px"
            >
                <filters-component
                    ref="filtersComponent"
                    @applica-filtri="applicaFiltri"
                    @close-dialog="filtersDialog = false"
                    @reload-table="getTecnici()"
                ></filters-component>
                <!-- @applica-filtri="filters = $event" -->
            </v-dialog>
            <!-- UPLOAD EXCEL TECNICI -->
            <template>
                <v-dialog
                    v-model="uploadExcelDialog"
                    max-width="800px"
                    persistent
                >
                    <v-card
                        plain
                        class="dark:!bg-csenBlue-900 dark:!ring-0 dark:!border-0 !rounded-md"
                    >
                        <v-card-title
                            class="bg-csenBlue-900 dark:bg-csenBlue-800 text-white font-bold text-2xl py-6 pl-8"
                        >
                            <span class="flex-grow">
                                <h2>
                                    Carica Excel dei tecnici associati ad un
                                    diploma
                                </h2>
                            </span>
                        </v-card-title>
                        <v-card-text class="!m-0 !p-0">
                            <v-form
                                v-model="validUploadExcel"
                                ref="formUploadExcel"
                            >
                                <div class="my-5 mx-8 !z-50">
                                    <v-autocomplete
                                        v-model="
                                            uploadExcelInfoDiploma.categoria_corso_id
                                        "
                                        autocomplete="none"
                                        :items="categorieCorsi"
                                        label="Categoria del corso"
                                        item-text="nome"
                                        item-value="id"
                                        class="!z-50"
                                        outlined
                                        :rules="[rules.required]"
                                    ></v-autocomplete>
                                    <v-autocomplete
                                        v-model="
                                            uploadExcelInfoDiploma.corso_id
                                        "
                                        autocomplete="none"
                                        :items="corsiByCategoriaId"
                                        label="Corso"
                                        item-text="nome"
                                        item-value="id"
                                        outlined
                                        class="!z-50"
                                        :rules="[rules.required]"
                                    ></v-autocomplete>
                                    <v-autocomplete
                                        v-model="
                                            uploadExcelInfoDiploma.edizione_id
                                        "
                                        autocomplete="none"
                                        :items="edizioniByCorsoId"
                                        label="Edizione"
                                        item-text="nome"
                                        item-value="id"
                                        outlined
                                        class="!z-50"
                                        :rules="[ruleEdizioneCorso]"
                                    ></v-autocomplete>
                                    <v-text-field
                                        v-model="
                                            uploadExcelInfoDiploma.data_conseguimento
                                        "
                                        label="Data di conseguimento diploma"
                                        outlined
                                        type="date"
                                        :rules="[rules.required]"
                                    >
                                    </v-text-field>
                                    <v-file-input
                                        v-model="fileExcelToUpload"
                                        label="Carica Excel (.xlsx)"
                                        accept=".xlsx, .xls"
                                        outlined
                                        :rules="[rules.required]"
                                    ></v-file-input>
                                </div>
                            </v-form>
                        </v-card-text>
                        <v-card-actions
                            class="p-4 justify-end bg-gray-300 dark:bg-csenBlue-800 sticky bottom-0 z-40"
                        >
                            <v-btn
                                :disabled="isUploadingExcel"
                                id="annulla-torna-elenco"
                                class="!bg-gray-400/30 dark:!bg-transparent !tracking-wider !py-5 !px-4"
                                text
                                @click="closeUploadExcelDialog()"
                            >
                                Annulla
                            </v-btn>
                            <v-btn
                                class="!bg-csenGreen-500 !text-white !tracking-wider !py-5 !px-5"
                                text
                                @click="uploadExcel()"
                            >
                                Carica
                                <v-progress-circular
                                    v-if="isUploadingExcel"
                                    :size="20"
                                    :width="3"
                                    class="ml-2 !fill-white"
                                    indeterminate
                                ></v-progress-circular>
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </template>
            <!-- PANNELLO ACCESSO AMMINISTRATIVO -->
            <v-dialog
                v-model="loginAdminDialog"
                width="600px"
                persistent
                @keyup.enter="doLoginAdmin()"
            >
                <v-card plain class="dark:!bg-csenBlue-800">
                    <v-card-title class="font-bold text-2xl py-6 pl-8">
                        <span class="flex-grow">
                            <h2>Accedi come amministratore</h2>
                        </span>
                        <v-btn
                            class="!text-gray-900 dark:!text-white"
                            icon
                            @click="closeLoginAdminDialog()"
                        >
                            <CloseIcon />
                        </v-btn>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text class="!m-0 !px-8 !py-8 !font-sans">
                        <div class="text-neutral-700 dark:text-white !mb-6">
                            <strong
                                >Questo accesso è riservato solo al
                                <span class="underline dark:text-csenOrange-500"
                                    >Personale Amministrativo CSEN</span
                                >.</strong
                            >
                            <p class="mt-1">
                                Se sei un tecnico e vuoi accedere alla tua
                                scheda personale, cerca il tuo nome nell'elenco
                                dei tecnici e clicca sul pulsante "Accedi"
                            </p>
                        </div>
                        <v-form ref="loginForm">
                            <v-text-field
                                v-model="adminEmail"
                                label="Email"
                                outlined
                                :rules="[rules.required, rules.email]"
                            ></v-text-field>
                            <v-text-field
                                v-model="adminPassword"
                                label="Password"
                                type="password"
                                outlined
                                :rules="[rules.required]"
                            ></v-text-field>
                        </v-form>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions
                        class="p-4 justify-end bg-white dark:bg-csenBlue-800"
                    >
                        <v-btn
                            class="!tracking-wider !py-5 !px-5"
                            text
                            @click="closeLoginAdminDialog()"
                        >
                            Annulla
                        </v-btn>
                        <v-btn
                            class="!bg-csenBlue-900 !text-white !tracking-wider !py-5 !px-5"
                            text
                            @click="doLoginAdmin()"
                        >
                            Accedi come amministratore
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <!-- VECCHIE FINESTRE DIALOG -->
            <v-dialog v-model="allCoursesDialog" width="unset" persistent>
                <v-card>
                    <v-card-title>
                        <span>Tutti i diplomi</span>
                        <v-spacer></v-spacer>
                        <v-icon @click="allCoursesDialog = false"
                            >mdi-close</v-icon
                        >
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-row class="flex-column">
                                <div
                                    v-for="(course, index) in selectedCourses"
                                    :key="index"
                                >
                                    &#8226; {{ course.Nome }}
                                </div>
                            </v-row>
                        </v-container>
                    </v-card-text>
                </v-card>
            </v-dialog>
            <v-dialog v-model="filterHeadersDialog" width="unset">
                <v-card>
                    <v-card-title>
                        <span class="mr-1">Mostra/nascondi colonne</span>
                        <v-spacer></v-spacer>
                        <v-icon @click="filterHeadersDialog = false"
                            >mdi-close</v-icon
                        >
                    </v-card-title>
                    <v-card-text>
                        <v-sheet outlined rounded class="py-3">
                            <v-treeview
                                :items="headersSuCuiFiltrare"
                                item-key="value"
                                item-text="text"
                                v-model="headersSelezionati"
                                selected-color="primary"
                                selectable
                                dense
                                open-all
                            >
                            </v-treeview>
                        </v-sheet>
                    </v-card-text>
                </v-card>
            </v-dialog>
            <!-- PANNELLO ESPORTAZIONE -->
            <template>
                <v-dialog v-model="exportDialog" width="600px" persistent>
                    <v-card plain class="dark:!bg-csenBlue-800">
                        <v-card-title class="font-bold text-2xl py-6 pl-8">
                            <span class="flex-grow">
                                <h2>Esporta elenco tecnici</h2>
                            </span>
                            <v-btn
                                class="!text-gray-900 dark:!text-white"
                                icon
                                @click="closeExportDialog()"
                            >
                                <CloseIcon />
                            </v-btn>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text class="!m-0 !px-8 !py-8 !font-sans">
                            <!-- Avviso se troppi record -->
                            <!-- v-if="numTotaleTecnici > 5000" -->
                            <div
                                v-if="false"
                                class="!mb-6 !p-4 !bg-csenRed-50 dark:!bg-csenRed-900/20 !border !border-csenRed-200 dark:!border-csenRed-700 !rounded-md"
                            >
                                <div class="flex items-start gap-2">
                                    <WarningIcon
                                        class="!text-csenRed-600 dark:!text-csenRed-400 !mt-0.5 flex-shrink-0"
                                    ></WarningIcon>
                                    <div
                                        class="text-sm text-csenRed-800 dark:text-csenRed-300"
                                    >
                                        <strong class="block mb-1"
                                            >Troppi record da esportare</strong
                                        >
                                        Stai tentando di esportare
                                        <strong>{{
                                            numTotaleTecnici.toLocaleString()
                                        }}</strong>
                                        tecnici, ma il limite massimo è di
                                        <strong>5.000 record</strong>. Per
                                        procedere con l'esportazione,
                                        <strong>applica dei filtri</strong> per
                                        ridurre il numero di tecnici in tabella.
                                    </div>
                                </div>
                            </div>

                            <div class="text-neutral-700 dark:text-white !mb-6">
                                <strong
                                    >Scegli il formato di esportazione</strong
                                >
                                <p class="mt-2 text-sm">
                                    Il file esportato conterrà solo i tecnici
                                    presenti in tabella in base ai filtri
                                    applicati.
                                    <!-- v-if="numTotaleTecnici <= 5000" -->
                                    <span
                                        class="block mt-1 font-semibold text-csenGreen-700 dark:text-csenGreen-400"
                                    >
                                        {{ numTotaleTecnici.toLocaleString() }}
                                        {{
                                            numTotaleTecnici === 1
                                                ? "tecnico"
                                                : "tecnici"
                                        }}
                                        da esportare
                                    </span>
                                </p>
                            </div>
                            <!-- :disabled="numTotaleTecnici > 5000" -->
                            <v-radio-group
                                v-model="exportFormat"
                                class="!mt-2"
                                row
                            >
                                <v-radio
                                    label="Excel (.xlsx)"
                                    value="excel"
                                    class="!mr-4"
                                ></v-radio>
                                <v-radio
                                    label="PDF (.zip)"
                                    value="pdf"
                                ></v-radio>
                            </v-radio-group>
                            <p
                                v-if="exportFormat === 'pdf'"
                                class="text-sm text-neutral-600 dark:text-neutral-300 !mb-0"
                            >
                                I PDF vengono suddivisi in file da massimo 5.000 tecnici e raccolti in un archivio ZIP.
                            </p>
                            <v-divider class="!my-4"></v-divider>
                            <div class="text-neutral-700 dark:text-white !mb-2">
                                <strong>Opzioni colonne</strong>
                            </div>
                            <!-- :disabled="numTotaleTecnici > 5000" -->
                            <v-checkbox
                                v-model="includeCodiceFiscale"
                                label="Includi colonna 'Codice Fiscale'"
                                class="!mt-2"
                            ></v-checkbox>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions
                            class="p-4 justify-end bg-white dark:bg-csenBlue-800"
                        >
                            <v-btn
                                class="!tracking-wider !py-5 !px-5"
                                text
                                @click="closeExportDialog()"
                            >
                                Annulla
                            </v-btn>
                            <!-- :disabled="numTotaleTecnici > 5000" -->
                            <v-btn
                                class="!bg-csenBlue-900 !text-white !tracking-wider !py-5 !px-5"
                                text
                                @click="confirmExport()"
                            >
                                Esporta
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </template>
            <!-- PANNELLO ESPORTAZIONE FINE -->
            <!-- VECCHIE FINESTRE DIALOG -->
            <!-- TO TOP -->
            <div
                class="flex fixed justify-end items-end bottom-6 md:bottom-5 right-6 md:right-5 bg-csenBlue-800 rounded-full px-2 py-2 !z-[60] cursor-pointer hover:bg-csenOrange-500 transition"
                @click="scrollToTop"
                title="Torna in cima"
            >
                <div><ChevronUpIcon></ChevronUpIcon></div>
            </div>
            <!-- FOOTER -->
            <div>
                <FooterComponent></FooterComponent>
            </div>
        </div>
        <v-tour
            ref="aaa"
            name="myTourTecnici"
            :steps="tourStepsTecnici"
            :options="tourOptions"
            :callbacks="tourCallbacks"
        ></v-tour>
        <!-- Overlay per bloccare i click durante il tour -->
        <div v-if="tourAvviato" class="tour-overlay"></div>
    </div>
</template>
<script>
import MenuComponent from "../components/MenuComponent.vue";
import FooterComponent from "../components/FooterComponent.vue";
import NewOrEditTechnicianComponent from "../components/NewOrEditTechnicianComponent.vue";
import ToggleThemeComponent from "../components/ToggleThemeComponent.vue";
import MenuTecnici from "../components/MenuTecnici.vue";
import mixin from "../mixin";
import store from "../store";
import PannelloTecniciComponente from "../components/PannelloTecniciComponente.vue";
import ModelloEmailComponent from "../components/ModelloEmailComponent.vue";

/* icone custom */
import EditIcon from "../components/icons/EditIcon.vue";
import DeleteIcon from "../components/icons/DeleteIcon.vue";
import RenewIcon from "../components/icons/RenewIcon.vue";
import GraduationIcon from "../components/icons/GraduationIcon.vue";
import StarIcon from "../components/icons/StarIcon.vue";
import UserIcon from "../components/icons/UserIcon.vue";
import FilterIcon from "../components/icons/FilterIcon.vue";
import FilterDisableIcon from "../components/icons/FilterDisableIcon.vue";
import LoginIcon from "../components/icons/LoginIcon.vue";
import LogoutIcon from "../components/icons/LogoutIcon.vue";
import VerifiedIcon from "../components/icons/VerifiedIcon.vue";
import WarningIcon from "../components/icons/WarningIcon.vue";
import DocumentIcon from "../components/icons/DocumentIcon.vue";
import TableIcon from "../components/icons/TableIcon.vue";
import PlusIcon from "../components/icons/PlusIcon.vue";
import CloseCircleIcon from "../components/icons/CloseCircleIcon.vue";
import CloseIcon from "../components/icons/CloseIcon.vue";
import LeftArrowIcon from "../components/icons/LeftArrowIcon.vue";
import SuccessIcon from "../components/icons/SuccessIcon.vue";
import InfoIcon from "../components/icons/InfoIcon.vue";
import PersonAddIcon from "../components/icons/PersonAddIcon.vue";
import UploadIcon from "../components/icons/UploadIcon.vue";
import BadgeNo from "../components/BadgeNo.vue";
import BadgeSi from "../components/BadgeSi.vue";

export default {
    components: {
        NewOrEditTechnicianComponent,
        MenuComponent,
        FooterComponent,
        ToggleThemeComponent,
        EditIcon,
        DeleteIcon,
        RenewIcon,
        GraduationIcon,
        StarIcon,
        UserIcon,
        FilterIcon,
        FilterDisableIcon,
        CloseCircleIcon,
        InfoIcon,
        PersonAddIcon,
        LeftArrowIcon,
        MenuTecnici,
        ModelloEmailComponent,
        LoginIcon,
        LogoutIcon,
        VerifiedIcon,
        WarningIcon,
        DocumentIcon,
        TableIcon,
        PlusIcon,
        PannelloTecniciComponente,
    },
    mixins: [mixin],
    data() {
        return {
            isCardVisible: true,
            pannelloTecnicoDialog: false,
            circolareDialog: false,
            circolareConfermaDialog: false,
            circolareFeedbackDialog: false,
            idTecnicoDaAprire: null, // Impostato all'id quando si clicca su un tecnico da modificare

            isTecnicoModificato: false,

            // Spostato nel computed
            // headers: [
            // 	{text: 'Cognome', value: 'cognome'},
            // 	{text: 'Nome', value: 'nome'},
            // 	{text: 'Città', value: 'residenza'},
            // 	{text: 'Ultimo Rinnovo', value: 'ultimo_rinnovo'},
            // 	{text: 'Diplomi', value: 'nomi_corsi'},
            // 	{text: 'Azioni', value: 'Azioni', sortable:false, class: 'text-end' },
            // ],

            tableKey: 0,

            isLoading: false,
            // darkMode: false,
            searchTechnician: null,
            searchTimeout: null,
            tableOptions: {}, // Contiene info come numero di elementi per pagina, pagina corrente, ecc. Gestiti in automatico da vuetify
            numTotaleTecnici: 0,
            tecnici: [],

            // headersNotLogged: [

            // ],
            // headersLogged: [

            // ],

            // hide/show columns
            headersSelezionati: [],
            filterHeadersDialog: false,

            technicianDialog: false,
            selectedTechnician: {},

            allCoursesDialog: false,
            selectedCourses: {},

            filtersDialog: false,
            filters: null,

            nomeCognomeTecnicoVisualizzato: null,
            search: null,
            searchTimer: null,

            loginTecnicoDialog: false,
            loginAdminDialog: false,
            richiestaLoginIDTecnico: null,
            suggerimentoEmail: null,
            suggerimentoEmailLoaded: false,
            emailInseritaLoginTecnico: null,

            filtri: null,
            numFiltriAttivi: 0,

            idModelloEmailCircolareSelezionato: null,
            modelliEmailDisponibili: [],
            // Se il modello selezionato ha il campo '{ANNO_RIFERIMENTO}'
            anniDisponibili: this.ottieniUltimiAnniPiuUno(),
            modelloEmailSelezionatoHasRiferimentoRinnovo: false,
            annoRinnovoRiferimentoCircolareSelezionato: null,

            vaiATabTecnico: null,

            isExportingPDF: false,
            isExportingExcel: false,
            isExporting: false,
            exportDialog: false,
            exportFormat: "excel",
            includeCodiceFiscale: false,

            tourAvviato: false,
            tourCallbacks: {
                onFinish: this.fineTour,
                onSkip: this.fineTour,
                onStop: this.fineTour,
            },
            tourStepsTecnici: [
                {
                    target: "#menu-tecnici-tab",
                    content: `
							Benvenuto, segui questa breve guida per scoprire quanto è semplice usare l'Albo Tecnici CSEN Corsi!<br/><br/>
							Nella barra del menù troverai tutti i pulsanti per accedere alle diverse sezioni dell'Albo (Tecnici, Corsi, Referenti, Modelli E-mail ecc.)<br/><br/>
							Partiamo vedendo la prima sezione: Tecnici.<br/><br/>
							Clicca su "Successivo" per continuare la guida.
						`,
                },
                {
                    target: "#search-bar",
                    content: `
							Qui siamo nella sezione Tecnici: usando questa barra puoi cercare un tecnico per Cognome, Nome, Email, Città o numero di telefono.<br/><br/>
							Cliccando su “Filtra” puoi filtrare la tabella dei Tecnici per altri parametri più dettagliati come per esempio anno o tipo di diploma, anno di rinnovo, zona geografica ecc.
						`,
                },
                {
                    target: "#tecnici-table",
                    content: `
							Qui puoi vedere la tabella con l'elenco di tutti i tecnici CSEN Corsi, con i dettagli riportati in ogni riga.<br/><br/>
							Ogni colonna con la freccetta nell'intestazione, si può ordinare cliccandoci sopra. I dati si disporranno in ordine crescente o decrescente in base alla freccetta.
						`,
                    // Mettendo il seguente scorre in basso e non si vede più la guida
                    // params: {
                    // 	placement: 'top' // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
                    // }
                },
                {
                    target: ".v-data-footer__select",
                    content: `
							In questa zona puoi aumentare il numero di righe della tabella visualizzabili per ogni pagina e cliccare sulle freccette per scorrere tra le pagine.
						`,
                },
                {
                    target: "#select-column",
                    content: `
							Se vuoi mostrare oppure nascondere altre colonne clicca invece su questa icona.
						`,
                },
                {
                    target: "#export-bar",
                    content: `
							Cliccando su questo pulsante puoi esportare l'elenco dei tecnici in formato Excel o PDF.<br>
							Il file scaricato conterrà solo i tecnici presenti in tabella in base ai filtri.
						`,
                },
                {
                    target: "#aggiugi-tecnico-btn",
                    content: `
							Per aggiungere un nuovo tecnico basta cliccare su questo pulsante.
						`,
                    before: () => {
                        // Chiamato anche quando torno indietro (magari il pannello tecnico era attivo)
                        this.chiudiPannelloTecnicoConferma();
                    },
                },

                // I seguenti sono presi dal Pannello Tecnico (alcuni condivisi con la guida dei tecnici):
                {
                    target: "#anagrafica-tab",
                    content: `
							Eccoci nella scheda dedicata ai dati del tecnico.<br/>
							In questa sezione puoi aggiungere tutti i suoi Dati anagrafici.<br/><br/>
							Il Codice Fiscale verrà creato automaticamente, verifica sempre che sia corretto e, se non lo fosse, puoi correggerlo a mano cliccando sull’icona della matita che trovi a fianco al campo “Codice Fiscale”.
						`,
                    params: {
                        placement: "right", // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
                    },
                    before: () => {
                        this.apriPannelloTecnico(null);

                        // Breve ritardo per assicurarsi che il pannello sia completamente aperto
                        // Nota: altrimenti non mostra gli step alla posizione corretta
                        let self = this;

                        return new Promise((resolve) => {
                            setTimeout(() => {
                                self.$refs.pannelloTecniciRef.spostaATab(0);
                                setTimeout(() => {
                                    // Attendo altri Xms prima di spostarmi alla tab 0 (utile se si va a ritroso)
                                    resolve();
                                }, 150);
                            }, 150);
                        });
                    },
                },
                {
                    target: "#contatti-tab",
                    content: `
							A seguire puoi aggiungere tutti i contatti del tecnico, ricorda che l'indirizzo email è sempre obbligatorio.
						`,
                    params: {
                        placement: "right", // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
                    },
                    before: () => {
                        this.$refs.pannelloTecniciRef.spostaATab(1);

                        // Breve ritardo per renderizzare correttamente tutto prima di cercare il tag target
                        // return new Promise(resolve => {
                        // 	setTimeout(() => {
                        // 		resolve();
                        // 	}, 300);
                        // });
                    },
                },
                {
                    target: "#indirizzi-tab",
                    content: `
							Nella terza sezione “Indirizzi” puoi inserire l'indirizzo di residenza, di domicilio e di spedizione del Tecnico.<br/>
							Basterà scorrere in basso per vedere tutti i campi.<br/><br/>
							1/2
						`,
                    params: {
                        placement: "right",
                        enableScrolling: false,
                    },
                    before: () => {
                        this.$refs.pannelloTecniciRef.spostaATab(2);

                        // Breve ritardo per renderizzare correttamente tutto prima di cercare il tag target
                        return new Promise((resolve) => {
                            setTimeout(() => {
                                // // Provo a scrollare rapidamente all'elemento interessato
                                // let element = document.getElementById("indirizzi-tab");
                                // element.scrollIntoView({
                                // 	block: 'center',  // Centra verticalmente
                                // 	inline: 'center'  // Centra orizzontalmente (se necessario)
                                // });

                                resolve();
                            }, 300);
                        });
                    },
                },
                {
                    target: "#indirizzi-tab-in-manuale",
                    content: `
							Quando devi inserire un indirizzo usa la barra di ricerca per trovarlo facilmente.<br/><br/>
							Se non lo trovi oppure qualche dato non è corretto, spunta la casella “Inserisci manualmente”.<br/><br/>
							Dopo aver inserito l’indirizzo di residenza, clicca sul pulsante “Copia indirizzo di residenza/domicilio” se coincidono.<br/><br/>
							2/2
						`,
                    params: {
                        placement: "bottom",
                        enableScrolling: false,
                    },
                    before: () => {
                        this.$refs.pannelloTecniciRef.spostaATab(2); // Chiamata andando a ritroso

                        // Breve ritardo per renderizzare correttamente tutto prima di cercare il tag target
                        return new Promise((resolve) => {
                            setTimeout(() => {
                                // // Provo a scrollare rapidamente all'elemento interessato
                                // let element = document.getElementById("indirizzi-tab-in");
                                // element.scrollIntoView({
                                // 	block: 'center',  // Centra verticalmente
                                // 	inline: 'center'  // Centra orizzontalmente (se necessario)
                                // });

                                resolve();
                            }, 300);
                        });
                    },
                },
                {
                    target: "#diplomi-tab",
                    content: `
							A seguire trovi la sezione che consente di aggiungere uno o più diplomi al nuovo tecnico.
						`,
                    params: {
                        placement: "right", // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
                    },
                    before: () => {
                        this.$refs.pannelloTecniciRef.spostaATab(3);

                        // Breve ritardo per renderizzare correttamente tutto prima di cercare il tag target
                        return new Promise((resolve) => {
                            setTimeout(() => {
                                resolve();
                            }, 300);
                        });
                    },
                },
                {
                    target: "#diplomi-crea-tecnico",
                    content: `
							Per poter aggiungere subito un diploma clicca prima sul pulsante “Crea nuovo tecnico” e poi su “Aggiungi diploma”.
						`,
                    before: () => {
                        this.$refs.pannelloTecniciRef.spostaATab(3); // Chiamata andando a ritroso

                        // Breve ritardo per renderizzare correttamente tutto prima di cercare il tag target
                        return new Promise((resolve) => {
                            setTimeout(() => {
                                resolve();
                            }, 300);
                        });
                    },
                },
                {
                    target: "#rinnovi-tab",
                    content: `
							Proseguendo troverai la sezione dedicata ai rinnovi del patentino del tecnico.
						`,
                    params: {
                        placement: "right", // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
                    },
                    before: () => {
                        this.$refs.pannelloTecniciRef.spostaATab(4);

                        // Breve ritardo per renderizzare correttamente tutto prima di cercare il tag target
                        return new Promise((resolve) => {
                            setTimeout(() => {
                                resolve();
                            }, 300);
                        });
                    },
                },
                {
                    target: "#rinnovi-crea-tecnico",
                    content: `
							Anche in questo caso, se non hai già creato il nuovo tecnico, per poter aggiungere subito un rinnovo, clicca prima sul pulsante “Crea nuovo tecnico” e poi su “Aggiungi rinnovo”.
						`,
                    before: () => {
                        this.$refs.pannelloTecniciRef.spostaATab(4); // Chiamata andando a ritroso

                        // Breve ritardo per renderizzare correttamente tutto prima di cercare il tag target
                        return new Promise((resolve) => {
                            setTimeout(() => {
                                resolve();
                            }, 300);
                        });
                    },
                },
                {
                    target: "#altri-dati-tab",
                    content: `
							Infine troverai la sezione “Altri dati del tecnico” nella quale puoi collegare un Referente, disabilitare la ricezione delle circolari massive e aggiungere delle Note specifiche sul tecnico.<br/><br/>
							Questa sezione è privata e non visibile al tecnico.
						`,
                    params: {
                        placement: "right", // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
                    },
                    before: () => {
                        this.$refs.pannelloTecniciRef.spostaATab(5);

                        // Breve ritardo per renderizzare correttamente tutto prima di cercare il tag target
                        return new Promise((resolve) => {
                            setTimeout(() => {
                                resolve();
                            }, 300);
                        });
                    },
                },
                {
                    target: "#annulla-torna-elenco",
                    content: `
							Ora che abbiamo concluso tutte le fasi dell'aggiunta del tecnico, chiudiamo questa scheda e ritorniamo all'elenco dei tecnici per scoprire le altre funzionalità dell'Albo.<br/><br/>
							Clicca su “Successivo” per proseguire!
						`,
                    before: () => {
                        // Chiamato anche quando si torna indietro:
                        this.apriPannelloTecnico(null);
                        this.$refs.pannelloTecniciRef.spostaATab(5);

                        // Breve ritardo per renderizzare correttamente tutto prima di cercare il tag target
                        return new Promise((resolve) => {
                            setTimeout(() => {
                                resolve();
                            }, 300);
                        });
                    },
                },
                {
                    target: "#modifica-tecnico",
                    content: `
							Se vuoi modificare o visualizzare tutti i dati di un tecnico già presente nell'elenco, clicca su questa icona per aprire di nuovo la sua scheda.
						`,
                    before: () => {
                        this.chiudiPannelloTecnicoConferma();
                    },
                },
                {
                    target: "#elimina-tecnico",
                    content: `
							Se vuoi eliminare un tecnico dall'Albo clicca sull'icona del cestino.
						`,
                },
                {
                    target: "#excel-import",
                    content: `
							Questo tasto consente di importare in blocco dei tecnici caricando il file Excel scaricato dall'App Iscritti.
						`,
                },
                {
                    target: "#invio-circolare-manuale",
                    content: `
							Attraverso questo pulsante puoi inviare una circolare a tutti i tecnici, scegliendo un modello di email già esistente.<br/><br/>
							Se vuoi inviarla a un gruppo specifico, usa prima il tasto "Filtra" per selezionare i tecnici a cui inviare la circolare.
						`,
                },
                {
                    target: "#menu-tecnici-tab",
                    content: `
							La guida della sezione Tecnici finisce qui!<br/><br/>
							Per vedere le guide delle altre sezioni, vai nelle altre pagine del menu.<br/><br/>
							Ricorda che puoi riaprire la guida in ogni momento cliccando sulla voce "Mostra Guida" in alto a destra.<br/><br/>
							Saluti sportivi!
						`,
                },

                // {
                // 	target: '#INSERIREID',
                // 	content: `
                // 		INSERIRE TESTO
                // 	`,
                // },

                // {
                // 	target: '#INSERIREID',
                // 	content: `
                // 		INSERIRE TESTO
                // 	`,
                // 	before: () => {
                // 		// INSERIRE AZIONE, ES:
                // 		// this.tab = 0
                // 	}
                // },
            ],

            uploadExcelDialog: false,

            validUploadExcel: null,

            // Per il caricamento dell'excel (serve prima selezionare il diploma = corso/edizione)
            categorieCorsi: [],
            corsiByCategoriaId: [],
            edizioniByCorsoId: [],
            uploadExcelInfoDiploma: {
                categoria_corso_id: null,
                corso_id: null,
                edizione_id: null,
                data_conseguimento: null,
            },
            fileExcelToUpload: null,
            isUploadingExcel: false,

            adminEmail: null,
            adminPassword: null,
        };
    },
    watch: {
        idModelloEmailCircolareSelezionato() {
            let res = false;
            this.modelliEmailDisponibili.some((modelloEmail) => {
                if (
                    modelloEmail.id == this.idModelloEmailCircolareSelezionato
                ) {
                    res = modelloEmail.has_anno_riferimento;
                    return true; // Per interrompere il some
                }
            });
            this.modelloEmailSelezionatoHasRiferimentoRinnovo = res;
        },
        tableOptions: {
            handler(newOptions, oldOptions) {
                this.getTecnici();
            },
            deep: true,
        },
        // computed value in mixin
        isLogged() {
            this.getTecnici();
        },
        filters() {
            this.getTecnici();
        },
        // headersSelezionati(newHeaders, oldHeaders) {
        // 	localStorage.setItem('selectedTechniciansHeaders', JSON.stringify(newHeaders));
        // },

        search: {
            handler(newVal, oldVal) {
                // Commentato IF perché devo cercare anche quando la barra viene svuotata a mano
                //if(this.search != null && this.search != ''){
                if (this.searchTimer) clearInterval(this.searchTimer);

                this.tableOptions.page = 1;
                this.searchTimer = setTimeout(this.getTecnici, 800);
                //}
            },
        },
        loggedAs: {
            handler() {
                if (this.loggedAs && this.loggedAs.ruolo == "admin") {
                    this.getCategorieCorsi();
                    this.getModelliEmail((data) => {
                        this.modelliEmailDisponibili = data;
                    });
                }
            },
            deep: true,
        },

        // ================ Upload Excel (Watchers) ================
        "uploadExcelInfoDiploma.categoria_corso_id": {
            handler(newVal, oldVal) {
                if (newVal != null) {
                    this.getCorsiByCategoriaCorsoId(
                        this.uploadExcelInfoDiploma.categoria_corso_id
                    );
                } else {
                    this.corsiByCategoriaId = [];
                    this.edizioniByCorsoId = [];
                }
                this.uploadExcelInfoDiploma.corso_id = null;
                this.uploadExcelInfoDiploma.edizione_id = null;
            },
        },
        "uploadExcelInfoDiploma.corso_id": {
            handler(newVal, oldVal) {
                if (newVal != null) {
                    this.getEdizioniByCorsoId(
                        this.uploadExcelInfoDiploma.corso_id
                    );
                } else {
                    this.edizioniByCorsoId = [];
                }
                this.uploadExcelInfoDiploma.edizione_id = null;
            },
        },
        // =========================================================
    },
    created() {
        this.getTecnici();

        if (this.loggedAs && this.loggedAs.ruolo == "admin") {
            this.getCategorieCorsi();
            this.getModelliEmail((data) => {
                this.modelliEmailDisponibili = data;
            });
        }
    },
    mounted() {
        // Nota: questo permette di decidere quali colonne mostrare di default
        // Evito di inserire di default indirizzo_completo_spedizione (lo useranno solo per le esportazioni)
        this.headersSelezionati = this.headers
            .filter(
                (header) => header.value !== "indirizzo_completo_spedizione"
            )
            .map((header) => header.value);

        if (!this.isGuidaCompleta("is_guida_tecnici_completa")) {
            this.tourAvviato = true;
            this.$tours["myTourTecnici"].start();
            this.setGuidaCompleta("is_guida_tecnici_completa");
        }
    },
    methods: {
        avviaTour() {
            this.tourAvviato = true;
            this.$tours["myTourTecnici"].start();
        },
        fineTour() {
            this.tourAvviato = false;
        },
        closeCard() {
            this.isCardVisible = false;
        },
        applicaFiltri(filtri, numFiltriAttivi) {
            this.numFiltriAttivi = numFiltriAttivi;
            this.filtri = JSON.parse(JSON.stringify(filtri));
            this.getTecnici();
        },
        apriPannelloTecnico(tecnico) {
            this.pannelloTecnicoDialog = true;
            if (tecnico) {
                this.idTecnicoDaAprire = tecnico.id;
                this.nomeCognomeTecnicoVisualizzato =
                    tecnico.nome + " " + tecnico.cognome;
            } else {
                this.idTecnicoDaAprire = null;
                this.nomeCognomeTecnicoVisualizzato = null;
            }
        },
        chiudiPannelloTecnicoConferma() {
            if (this.isTecnicoModificato) {
                store.commit("mostraDialogConferma", {
                    titolo: "Esci senza salvare le modifiche",
                    testo: "Sono presenti delle modifiche, vuoi uscire senza salvarle?",
                    onConferma: () => {
                        this.chiudiPannelloTecnico();
                        store.commit("nascondiDialogConferma");
                    },
                    onAnnulla: () => {
                        store.commit("nascondiDialogConferma");
                    },
                });
            } else {
                this.chiudiPannelloTecnico();
            }
        },
        chiudiPannelloTecnico() {
            this.pannelloTecnicoDialog = false;
            this.idTecnicoDaAprire = null;
            this.nomeCognomeTecnicoVisualizzato = null;

            this.isTecnicoModificato = false;

            // Il reset lo chiamo anche da qui per maggior sicurezza:
            try {
                this.$refs.pannelloTecniciRef.reset();
            } catch (error) {}
        },
        // Funzione che mostra tutti i diplomi
        mostraTuttiICorsi(item) {
            item.mostra_tutti_i_corsi = true;

            this.tecnici = [...this.tecnici]; // Forzo il re-rendering (senza utilizzare più la key che genera invece nuove richieste)
            // this.tableKey = this.tableKey+1;
        },
        validaTecnico(chiudiDialog = true, vaiATab = null) {
            // Per poi proseguire con l'inserimento/modifica
            if (this.$refs.pannelloTecniciRef.validaTecnico()) {
                this.$refs.pannelloTecniciRef.aggiungiModificaTecnico(
                    (tecnico) => {
                        store.commit("mostraSnack", {
                            messaggio: "Tecnico modificato con successo",
                            tipo: "success",
                        });
                        if (chiudiDialog) {
                            this.chiudiPannelloTecnico();
                            this.getTecnici();
                        } else {
                            this.chiudiPannelloTecnico(); // Chiudo e riapro il pannello impostando le informazioni del tecnico
                            this.apriPannelloTecnico(tecnico);
                            if (vaiATab) {
                                this.vaiATabTecnico = vaiATab;
                            }
                        }
                    }
                );
            } else {
                store.commit("mostraSnack", {
                    messaggio:
                        "Campi obbligatori non compilati, per favore ricontrollare",
                    tipo: "warning",
                });
            }
        },

        // aggiungiModificaTecnico(){...} // Spostato nel mixin (utilizzato anche da PannelloTecnici)

        doLoginAdmin() {
            if (!this.$refs["loginForm"].validate()) return;

            axios
                .post(`/login`, {
                    email: this.adminEmail, //'demo',
                    password: this.adminPassword, //'demo'
                })
                .then((res) => {
                    if (res.data.result == "success") {
                        window.location.reload();
                        // TODO: ho refreshato perché altrimenti non ho le info sulle guide visualizzate dall'admin
                        // store.commit('login', {ruolo: 'admin', id: res.data.id});
                        // this.closeLoginAdminDialog();

                        // store.commit('mostraSnack', {messaggio: 'Accesso eseguito come amministratore', tipo: 'success'})
                    } else {
                        store.commit("mostraSnack", {
                            messaggio: "Credenziali errate",
                            tipo: "error",
                        });
                        store.commit("logout");
                    }
                });
        },

        // ============== Upload Excel ==============
        openUploadExcelDialog() {
            this.uploadExcelDialog = true;
        },
        closeUploadExcelDialog() {
            this.uploadExcelDialog = false;

            this.uploadExcelInfoDiploma.categoria_corso_id = null;
            this.uploadExcelInfoDiploma.corso_id = null;
            this.uploadExcelInfoDiploma.edizione_id = null;
            this.uploadExcelInfoDiploma.data_conseguimento = null;

            this.fileExcelToUpload = null;

            try {
                this.$refs["formUploadExcel"].resetValidation();
            } catch (error) {}
        },
        getCategorieCorsi() {
            axios.get("/categorie_corsi").then((response) => {
                this.categorieCorsi = response.data;
            });
        },
        getCorsiByCategoriaCorsoId(categoriaCorsoId) {
            axios
                .get("/corsi_by_categoria_id?id=" + categoriaCorsoId)
                .then((response) => {
                    this.corsiByCategoriaId = response.data;
                });
        },
        getEdizioniByCorsoId(corsoId) {
            axios
                .get("/edizioni_by_corso_id?id=" + corsoId)
                .then((response) => {
                    this.edizioniByCorsoId = response.data;
                });
        },
        uploadExcel() {
            if (!this.$refs["formUploadExcel"].validate()) return;

            if (this.isUploadingExcel) return;

            this.isUploadingExcel = true;

            let formData = new FormData();
            formData.append("excel_file", this.fileExcelToUpload);
            formData.append("corso_id", this.uploadExcelInfoDiploma.corso_id);
            formData.append(
                "edizione_id",
                this.uploadExcelInfoDiploma.edizione_id
            );
            formData.append(
                "data_conseguimento",
                this.uploadExcelInfoDiploma.data_conseguimento
            );

            axios
                .post("/upload-excel-tecnici", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then((res) => {
                    store.commit("mostraSnack", {
                        messaggio: "Caricamento andato a buon fine",
                        tipo: "success",
                    });
                    this.closeUploadExcelDialog();
                    this.getTecnici();
                })
                .finally(() => {
                    this.isUploadingExcel = false;
                });
        },
        // ==========================================

        openLoginTecnicoDialog(tecnicoId) {
            this.suggerimentoEmailLoaded = false;

            this.loginTecnicoDialog = true;

            // Memorizzo l'id del tecnico che desidera entrare
            this.richiestaLoginIDTecnico = tecnicoId;

            // Chiedo al server il suggerimento dell'email:
            axios
                .get(`/suggerisci_email/${tecnicoId}`)
                .then((res) => {
                    this.suggerimentoEmail = res.data.toLowerCase();
                    this.suggerimentoEmailLoaded = true;
                })
                .finally(() => {});
        },
        doLoginTecnico() {
            axios
                .post(`/crea_token_accesso`, {
                    tecnico_id: this.richiestaLoginIDTecnico,
                    email: this.emailInseritaLoginTecnico,
                })
                .then((res) => {
                    this.loginTecnicoDialog = false;
                    store.commit("mostraSnack", {
                        messaggio: "Email inviata con successo!",
                        tipo: "success",
                    });
                })
                .catch((err) => {})
                .finally(() => {
                    // this.richiestaLoginIDTecnico = null; // Non devo azzerarlo!
                    this.emailInseritaLoginTecnico = null;
                });
        },

        openFilterHeadersDialog() {
            this.filterHeadersDialog = true;
        },
        openFiltersDialog() {
            this.filtersDialog = true;
            this.$nextTick(() => {
                // Per essere sicuro che il dialog è stato montato e ha le funzioni disponibili
                this.$refs.filtersComponent.controllaIsAdmin();
            });
        },
        resetFilters() {
            this.filters = null;
            this.$refs.filtersComponent.resetFilters();
        },

        /* MODALI DELLA CIRCOLARE */
        resetCircolareMassiva() {
            this.idModelloEmailCircolareSelezionato = null;
            this.annoRinnovoRiferimentoCircolareSelezionato = null;

            try {
                this.$refs["selezionaCircolareForm"].resetValidation();
            } catch (error) {}
        },
        openCircolareDialog() {
            this.circolareDialog = true;
        },
        closeCircolareDialog() {
            this.circolareDialog = false;

            this.resetCircolareMassiva();
        },

        openCircolareConfermaDialog() {
            if (!this.$refs["selezionaCircolareForm"].validate()) return;

            this.circolareDialog = false;
            this.circolareConfermaDialog = true;
        },
        closeCircolareConfermaDialog() {
            this.circolareConfermaDialog = false;
            this.circolareDialog = true;
        },

        openCircolareFeedbackDialog() {
            axios
                .post(`/circolare_invio_massivo_istantaneo`, {
                    modello_email_id: this.idModelloEmailCircolareSelezionato,
                    anno_riferimento_rinnovo:
                        this.annoRinnovoRiferimentoCircolareSelezionato,
                    tecniciSearch: this.search != null ? this.search : "", // Per ottenere i tecnici filtrati
                    tecniciFilters: this.filtri,
                })
                .then((res) => {
                    this.circolareConfermaDialog = false;
                    this.circolareFeedbackDialog = true;
                });
        },
        closeCircolareFeedbackDialog() {
            this.circolareFeedbackDialog = false;

            this.resetCircolareMassiva();
        },

        openAllCoursesDialog(courses) {
            this.allCoursesDialog = true;
            this.selectedCourses = courses;
        },
        newTechnician() {
            this.technicianDialog = true;
            this.selectedTechnician = null;
        },
        editTechnician(item) {
            if (this.isLogged) {
                this.technicianDialog = true;
                this.selectedTechnician = item;
            }
        },
        getTecnici() {
            this.isLoading = true;
            // axios.get(`/tecnici?page=${this.options.page}&itemsPerPage=${this.options.itemsPerPage}&search=${toSearch != null ? toSearch : ''}`)

            // Devo fare una post per passare i dati, tra cui i filtri da utilizzare:
            axios
                .post(`/tecnici_filtrati`, {
                    page: this.tableOptions.page,
                    itemsPerPage: this.tableOptions.itemsPerPage,
                    search: this.search != null ? this.search : "",
                    filters: this.filtri,
                    options: this.tableOptions,
                })
                .then((res) => {
                    this.tecnici = res.data.data;
                    this.numTotaleTecnici = res.data.total;

                    this.tecnici.forEach((tecnico) => {
                        tecnico.mostra_tutti_i_corsi = false;
                    });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        openLoginAdminDialog() {
            this.loginAdminDialog = true;
        },
        closeLoginAdminDialog() {
            this.loginAdminDialog = false;
        },

        esportaPDF(includeCodiceFiscale = false) {
            if (this.isExportingPDF) return;

            this.isExportingPDF = true;
            this.isExporting = true;

            let headers = [];
            this.headersDaMostrare.forEach((obj) => {
                if (obj.value != "azioni")
                    // Evito la colonna azioni
                    headers.push(obj);
            });

            // Aggiunge la colonna Codice Fiscale dopo Nome se richiesto
            if (includeCodiceFiscale) {
                const nomeIndex = headers.findIndex((h) => h.value === "nome");
                const codiceFiscaleExists = headers.some(
                    (h) => h.value === "codice_fiscale"
                );

                if (nomeIndex !== -1 && !codiceFiscaleExists) {
                    headers.splice(nomeIndex + 1, 0, {
                        text: "Codice fiscale",
                        value: "codice_fiscale",
                        sortable: false,
                    });
                }
            }

            let params = {
                search: this.search != null ? this.search : "",
                filters: this.filtri,
                options: this.tableOptions,
                headers: headers,
            };

            // Invia la richiesta POST al server
            axios
                .post("tecnici/pdf", params, {
                    responseType: "blob", // Importante! Indica che la risposta sarà un blob (file binario)
                })
                .then((response) => {
                    console.log(response);
                    // // Crea un URL per il blob
                    const blob = new Blob([response.data], {
                        type: "application/zip",
                    });
                    const link = document.createElement("a");
                    link.href = window.URL.createObjectURL(blob);
                    link.download = "Csen - Tecnici.zip"; // Nome del file che vuoi scaricare
                    link.click(); // Simula il clic per avviare il download

                    // Libera la memoria dopo il download
                    window.URL.revokeObjectURL(link.href);

                    this.isExportingPDF = false;
                    this.isExporting = false;
                })
                .catch((error) => {
                    console.error("Errore durante il download del PDF", error);

                    // Mostra messaggio di errore se proviene dal backend
                    if (
                        error.response &&
                        error.response.data &&
                        error.response.data.message
                    ) {
                        store.commit("mostraSnack", {
                            messaggio: error.response.data.message,
                            tipo: "error",
                            durata: 8000,
                        });
                    } else {
                        store.commit("mostraSnack", {
                            messaggio: "Errore durante il download del PDF",
                            tipo: "error",
                        });
                    }

                    this.isExportingPDF = false;
                    this.isExporting = false;
                });
        },

        esportaExcelNew(includeCodiceFiscale = false) {
            if (this.isExportingExcel) return;

            this.isExportingExcel = true;
            this.isExporting = true;

            let headers = [];
            this.headersDaMostrare.forEach((obj) => {
                if (obj.value != "azioni")
                    // Evito la colonna azioni
                    headers.push(obj);
            });

            // Aggiunge la colonna Codice Fiscale dopo Nome se richiesto
            if (includeCodiceFiscale) {
                const nomeIndex = headers.findIndex((h) => h.value === "nome");
                const codiceFiscaleExists = headers.some(
                    (h) => h.value === "codice_fiscale"
                );

                if (nomeIndex !== -1 && !codiceFiscaleExists) {
                    headers.splice(nomeIndex + 1, 0, {
                        text: "Codice fiscale",
                        value: "codice_fiscale",
                        sortable: false,
                    });
                }
            }

            let params = {
                search: this.search != null ? this.search : "",
                filters: this.filtri,
                options: this.tableOptions,
                headers: headers,
            };

            // Invia la richiesta POST al server
            axios
                .post("tecnici/excel", params, {
                    responseType: "blob", // Importante! Indica che la risposta sarà un blob (file binario)
                })
                .then((response) => {
                    console.log(response);
                    // // Crea un URL per il blob
                    const blob = new Blob([response.data], {
                        type: "application/pdf",
                    });
                    const link = document.createElement("a");
                    link.href = window.URL.createObjectURL(blob);
                    link.download = "Csen - Tecnici.xlsx"; // Nome del file che vuoi scaricare
                    link.click(); // Simula il clic per avviare il download

                    // Libera la memoria dopo il download
                    window.URL.revokeObjectURL(link.href);
                    this.isExportingExcel = false;
                    this.isExporting = false;
                })
                .catch((error) => {
                    console.error(
                        "Errore durante il download del file Excel",
                        error
                    );

                    // Mostra messaggio di errore se proviene dal backend
                    if (
                        error.response &&
                        error.response.data &&
                        error.response.data.message
                    ) {
                        store.commit("mostraSnack", {
                            messaggio: error.response.data.message,
                            tipo: "error",
                            durata: 8000,
                        });
                    } else {
                        store.commit("mostraSnack", {
                            messaggio:
                                "Errore durante il download del file Excel",
                            tipo: "error",
                        });
                    }

                    this.isExportingExcel = false;
                    this.isExporting = false;
                });
        },

        openExportDialog() {
            this.exportDialog = true;
        },

        closeExportDialog() {
            this.exportDialog = false;
            // Reset dei valori al default
            this.exportFormat = "excel";
            this.includeCodiceFiscale = false;
        },

        confirmExport() {
            // Chiudi la modale
            this.exportDialog = false;

            // Esegui l'esportazione in base al formato scelto
            if (this.exportFormat === "excel") {
                this.esportaExcelNew(this.includeCodiceFiscale);
            } else if (this.exportFormat === "pdf") {
                this.esportaPDF(this.includeCodiceFiscale);
            }

            // Reset dei valori dopo l'esportazione
            this.exportFormat = "excel";
            this.includeCodiceFiscale = false;
        },

        resetSearch() {
            this.search = null;
            this.tableOptions.page = 1;
            this.getTecnici();
        },

        visualizzaInteroPannelloTecnico(idTecnico) {
            this.$router.replace({
                name: "pannellotecnici",
                params: { tecnicoid: idTecnico },
            });
        },

        eliminaTecnico(tecnicoObj) {
            store.commit("mostraDialogConferma", {
                titolo: "Elimina tecnico",
                testo: `Sicuro di voler eliminare il tecnico ${tecnicoObj.nome} ${tecnicoObj.cognome}?`,
                onConferma: () => {
                    axios.delete(`/tecnici/${tecnicoObj.id}`).then((res) => {
                        this.getTecnici();
                        store.commit("mostraSnack", {
                            messaggio: "Tecnico eliminato con successo",
                            tipo: "success",
                        });
                    });
                    store.commit("nascondiDialogConferma");
                },
                onAnnulla: () => {
                    store.commit("nascondiDialogConferma");
                },
            });
        },

        isUltimoRinnovoDaMostrare(annoUltimoRinnovo) {
            return annoUltimoRinnovo >= new Date().getFullYear();
        },

        getRigaTecnicoClass(item) {
            return item.is_visibile == 0
                ? "bg-tecnico-invisibile-light dark:!bg-tecnico-invisibile-dark"
                : "";
        },

        // Questa non va bene perché il caricamento dei tecnici è asincono, questa cercherebbe solo sui tecnici già caricati
        // ricercaPersonalizzata(value, search, item){
        // 	if(!search)
        // 		return true;

        // 	let nomeCompleto = `${item.nome} ${item.cognome}`.toLowerCase();
        // 	let nomeCompletoInverso = `${item.cognome} ${item.nome}`.toLowerCase();
        // 	if(nomeCompleto.includes(search.toLowerCase()) || nomeCompletoInverso.includes(search.toLowerCase()))
        // 		return true;

        // 	let trovato = false;
        // 	this.headers.forEach(headerObj => {
        // 		// Nota: in realtà nome e cognome li ha già cercati precedentemente
        // 		if(header.searchable !== false && item[header.value].toLowerCase().includes(search.toLowerCase())){
        // 			trovato = true;
        // 		}
        // 	})
        // 	return trovato;
        // }
    },
    computed: {
        headers() {
            let headers = [
                { text: "Cognome", value: "cognome" },
                { text: "Nome", value: "nome" },
                { text: "Comune di residenza", value: "residenza" }, // Restituito già in forma comune (PROV) dal BE
                { text: "Ultimo rinnovo", value: "ultimo_rinnovo" },
                {
                    text: "Diplomi",
                    value: "nomi_corsi",
                    sortable: false,
                    width: "300px",
                },
            ];

            if (this.loggedAs && this.loggedAs.ruolo == "admin") {
                headers.push(
                    {
                        text: "Data di nascita",
                        value: "data_nascita",
                        sortable: false,
                    },
                    {
                        text: "Comune di nascita",
                        value: "comune_provincia_nascita",
                        sortable: false,
                    }, // Restituito già formattato dal BE
                    {
                        text: "Codice fiscale",
                        value: "codice_fiscale",
                        sortable: false,
                    },
                    {
                        text: "Indirizzo di spedizione",
                        value: "indirizzo_completo_spedizione",
                        sortable: false,
                    },
                    {
                        text: "Ricezione delle circolari massive",
                        value: "circolari_abilitate",
                        sortable: false,
                    },
                    { text: "Email", value: "email", sortable: false },
                    { text: "Cellulare", value: "cellulare", sortable: false },
                    {
                        text: "Referente",
                        value: "referente.nome_e_simbolo_autonomo",
                        sortable: false,
                    }
                );
            }

            if (this.loggedAs.ruolo != "tecnico") {
                headers.push({
                    text: "Azioni",
                    value: "azioni",
                    sortable: false,
                    class: "text-end",
                });
            }

            return headers;
        },
        headersSuCuiFiltrare() {
            return [
                {
                    value: "headers",
                    text: "Tutte le colonne",
                    children: this.headers.map((header) => ({
                        value: header.value,
                        text: header.text,
                    })),
                },
            ];
        },
        headersDaMostrare() {
            return this.headers.filter((header) =>
                this.headersSelezionati.includes(header.value)
            );
        },
        // excelColumns() {
        // 	let colonne = this.headersDaMostrare.map(header => {
        // 		return {
        // 			'label': header.text,
        // 			'field': header.value
        // 		}
        // 	});

        // 	return colonne
        // },
        // excelData() {
        // 	// TODO: non va più bene con la gestione asincrona (i tecnici non sono tutti)
        // 	let res = this.tecnici.map(tecnico => {
        // 		let diplomiString = "";
        // 		tecnico.nomi_corsi.forEach((nomeCorso, idx) => {
        // 			if(idx != 0){
        // 				diplomiString += " | "
        // 			}
        // 			diplomiString += nomeCorso
        // 		});

        // 		if (this.loggedAs && this.loggedAs.ruolo == 'admin'){
        // 			return {
        // 				cognome: tecnico.cognome,
        // 				nome: tecnico.nome,
        // 				residenza: tecnico.comune_residenza + "(" + tecnico.sigla_provincia_residenza + ")",
        // 				email: tecnico.email,
        // 				telefono: tecnico.telefono_fisso,
        // 				cellulare: tecnico.cellulare,
        // 				nomi_corsi: diplomiString
        // 			}
        // 		} else {
        // 			return {
        // 				cognome: tecnico.cognome,
        // 				nome: tecnico.nome,
        // 				residenza: tecnico.comune_residenza + " (" + tecnico.sigla_provincia_residenza + ")",
        // 				nomi_corsi: diplomiString
        // 			}
        // 		}
        // 	});

        // 	return res;
        // },
        nomeModelloEmailCircolareSelezionatoComputed() {
            // Trovato a partire dall'ID selezionato
            let nomeModello = "";
            if (this.idModelloEmailCircolareSelezionato !== null) {
                this.modelliEmailDisponibili.some((mod) => {
                    if (mod.id == this.idModelloEmailCircolareSelezionato) {
                        nomeModello = mod.nome;
                        return true;
                    }
                });
            }

            return nomeModello;
        },

        ruleEdizioneCorso() {
            // Se il corso selezionato non ha edizioni, la validazione va sempre a buon fine
            if (this.edizioniByCorsoId.length == 0) {
                return true;
            } else {
                // Altrimenti è necessario aver selezionato l'edizione
                if (
                    this.uploadExcelInfoDiploma.edizione_id != null &&
                    this.uploadExcelInfoDiploma.edizione_id != ""
                ) {
                    return true;
                } else {
                    return "E' necessario selezionare l'edizione";
                }
            }
        },
    },
};
</script>
<!--
 <style>
	.tecnico-invisibile{
		background: repeating-linear-gradient(
		45deg,
		#f3f4f6,
		#f3f4f6 10px,
		#e5e7eb 10px,
		#e5e7eb 20px);
	}
 </style> -->

<style lang="scss" scoped>
.tabella-csen {
    background-color: #fff;
    ::v-deep .v-data-table__wrapper th {
        color: #27316e !important;
        font-size: 15px !important;
        background-color: #eef5ff;
        padding: 1rem;
    }
}
.dark {
    ::v-deep .v-data-table__wrapper th {
        color: #c7dcfe !important;
        font-size: 15px !important;
        padding: 1rem;
    }
}

::v-deep .theme--dark .v-messages__message {
    color: #fff !important;
}
</style>
